var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUdsNeedsImage22(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.98,5.01H12.02c-3.86,0-7,3.14-7,7V47.97c0,3.86,3.14,7,7,7h8.92v.02h4v-.02h10.13v.02h4v-.02h8.92c3.86,0,7-3.14,7-7V12.01c0-3.86-3.14-7-7-7Zm3,7v8.92h-11.92V9.01h8.92c1.65,0,3,1.35,3,3Zm-26.04,12.92h10.13v10.13h-10.13v-10.13Zm-4,10.13H9.02v-10.13h11.92v10.13Zm4-14.13V9.01h10.13v11.92h-10.13Zm14.13,4h11.92v10.13h-11.92v-10.13ZM12.02,9.01h8.92v11.92H9.02V12.01c0-1.65,1.35-3,3-3Zm0,41.96c-1.65,0-3-1.35-3-3v-8.92h11.92v11.92H12.02Zm12.92,0v-11.92h10.13v11.92h-10.13Zm23.04,0h-8.92v-11.92h11.92v8.92c0,1.65-1.35,3-3,3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdsNeedsImage22);
export default __webpack_public_path__ + "static/media/UDS Needs Image-22.5ef2b37a2afafd93f7d5f621ef705f69.svg";
export { ForwardRef as ReactComponent };